import { MarcusActionTimeline } from "./MarcusActionTimeline";
import { MarcusGhostCursor } from "./MarcusGhostCursor";

export function MarcusAutopilotOverlay({ showTimeline = true }: { showTimeline?: boolean }) {
  return (
    <>
      {showTimeline && (
        <div className="pointer-events-none fixed inset-x-0 top-3 z-[80] mx-auto flex w-fit max-w-[min(720px,90vw)] justify-center">
          <div className="pointer-events-auto">
            <MarcusActionTimeline />
          </div>
        </div>
      )}
      <MarcusGhostCursor />
    </>
  );
}

export default MarcusAutopilotOverlay;
